;(function () {
  'use strict'

  angular
    .module('contrast.services.user.keys')
    .factory('userKeysService', userKeysService)

  function userKeysService(
    ServiceUtils,
    logger,
    rotateKeyModalService,
    ProfileFactory,
    ErrorService,
    KEY_TYPES
  ) {
    'ngInject'

    var service = {
      rotateServiceKey: rotateServiceKey,
      getServiceKeys: getServiceKeys
    }

    return service

    function rotateServiceKey(updateUserKeysFn) {
      rotateKeyModalService
        .openRotateKeyModal(KEY_TYPES.USER_SERVICE_KEY)
        .then(function () {
          return ProfileFactory.rotateUserKey()
            .then(function (response) {
              logger.logSuccess(response.data.messages[0])
              updateUserKeysFn()
            })
            .catch(ErrorService.processError)
        })
    }

    function getServiceKeys() {
      return ProfileFactory.getKeys()
        .then(ServiceUtils.handleResolve('data'))
        .catch(ServiceUtils.handleError)
    }
  }
})()
